export default "__VITE_ASSET__BTlcH68X__"